import { Box, Button, Grid } from '@mui/material'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

import KanseiBreadcrumbs from 'components/breadcrumb'
import KanseiDatePicker from 'components/datePicker'
import KanseiSimpleSelectBox from 'components/simpleSelectBox'
import KanseiTextField from 'components/textField'
import { groupApi } from 'hooks/api/group'
import { CompanyGroup } from 'types/group'
import { Option } from 'types/option'

import CompanyLinks from './company'

interface Form {
  name: string
  parentId?: string
  deletedAt?: string
}

export default function DetailPage() {
  const [group, setGroup] = useState<CompanyGroup>()
  const [options, setOptions] = useState<Option[]>([])
  const [selectAction, setSelectAction] = useState<string>()
  const { id } = useParams<{ id: string }>()
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm<Form>()

  const handleSelectAction = (value: string) => {
    setSelectAction(value)
  }

  const fetchData = async () => {
    const res = await groupApi().findById(id!)
    const groupData = res.data
    const deletedAt: string | undefined = groupData.deletedAt
      ? dayjs(groupData.deletedAt).format('YYYY-MM-DD')
      : undefined
    const form: Form = {
      name: groupData.name,
      parentId: groupData.parentId,
      deletedAt: deletedAt,
    }
    reset(form)
    setGroup(groupData)

    const groupsRes = await groupApi().getAll()
    const options: Option[] = groupsRes.data
      .map((group) => {
        // 自分自身と親が自分のグループを除外
        const isSelf = group.id === groupData.id
        const isParent = group.parentId === groupData.id
        if (!isSelf && !isParent) {
          return {
            label: group.name,
            value: group.id,
          }
        }
      })
      .filter(Boolean) as Option[]
    setOptions(options)
    const selectedOption = options.find((option) => {
      return option.value === groupData.parentId
    })
    if (selectedOption) {
      setSelectAction(String(selectedOption.value))
    }
  }

  const handleOnChange = () => {
    fetchData()
  }

  useEffect(() => {
    fetchData()
  }, [])

  const onSubmit = (form: Form) => {
    const parentId = options.find((x) => x.value === selectAction)?.value

    const data = {
      name: form.name,
      parentId: parentId ? String(parentId) : undefined,
      deletedAt: !form.deletedAt ? undefined : dayjs(form.deletedAt),
    }

    // 削除日が設定されている場合window.promptで削除と乳録されたら実行する
    if (
      data.deletedAt !== undefined &&
      window.prompt(
        '削除日が設定されています。削除する場合は削除と入力してください',
      ) !== '削除'
    ) {
      setValue('deletedAt', '')
      alert('削除がキャンセルされました。')
      return
    }

    groupApi()
      .edit(id!, data)
      .then(() => {
        alert('更新しました。')
        fetchData()
      })
  }

  const links = [
    {
      title: 'グループ管理一覧',
      to: '/group',
    },
    {
      title: group ? group.name : '',
    },
  ]

  return (
    <Box>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{ '& .MuiTextField-root': { m: 1 }, maxWidth: '500px' }}
      >
        <KanseiBreadcrumbs links={links} style={{ marginBottom: '15px' }} />
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <KanseiTextField
              id="name"
              label="グループ管理名"
              control={control}
              errors={errors}
              required
            />
          </Grid>
          {options.length > 0 && (
            <Grid item xs={8}>
              <KanseiSimpleSelectBox
                style={{ width: '250px', margin: '8px' }}
                options={options}
                value={selectAction}
                onChange={handleSelectAction}
              ></KanseiSimpleSelectBox>
            </Grid>
          )}
          <Grid item xs={4}>
            <KanseiDatePicker
              name="deletedAt"
              style={{ width: '160px' }}
              control={control}
              format={'YYYY/MM/DD'}
            />
          </Grid>
        </Grid>
        <Button type="submit" variant="contained" sx={{ mt: 2 }}>
          更新
        </Button>
      </Box>
      <CompanyLinks companyGroup={group} onChange={handleOnChange} />
    </Box>
  )
}
